import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('scrollable-textarea', {
  viewModel: {
    createViewModel: (params, componentInfo) => new ViewModel(params, componentInfo.element)
  },
  template: html
});

